import {CHAPTER_SELECTED} from "../actions/actionTypes";

export default function (state = [], action) {
    switch (action.type) {
        case CHAPTER_SELECTED:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/chapter_active.js